import searchIcon from '../components/Svg/searchIcon'

export const searchFormInfo = {
  components: {
    searchIcon
  },
  data() {
    return {
      filter:  ''
    }
  }
}
